export default __webpack_public_path__ + "static/media/FIAssembly-02.258bd975.png";